import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ExportarPublicaciones from './Components/ExportarPublicaciones';
import ExportarOrdenes from './Components/ExportarOrdenes';
import ExportarNovedades from './Components/ExportarNovedades';
import ExportarLiquidaciones from './Components/ExportarLiquidaciones';

export default class AdmExportables extends React.Component {
    render() {
        return (
            <div>
                <Routes>
                    <Route path="" element={<ExportarPublicaciones/>}/>
                    <Route path="Publicaciones" element={<ExportarPublicaciones/>}/>
                    <Route path="Ordenes" element={<ExportarOrdenes/>}/>
                    <Route path="Novedades" element={<ExportarNovedades/>}/>
                    <Route path="Liquidaciones" element={<ExportarLiquidaciones/>}/>
                </Routes>
            </div>
        );
    }
}